import React, { useState, useContext, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, User, LogOut, Menu, X, Bell } from "lucide-react";
import SuryaLogoMain from "../../assets/images/Jobmongo-logo.png";
import DummyImg from "../../assets/images/user-dummy-img.jpg";
import LogoutConfirmModal from "./LogoutConfirmModal";
import { AuthContext } from "../../Context/ContextFunctions";
import { FaUserShield } from "react-icons/fa";
import Profile from "./ProfileModal";
const Navbar = () => {
  const dropdownRef = useRef(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [userProfileOpenPopup, setUserProfileOpenPopup] = useState(false);
  const [showConfirmationModal, setConfirmationModal] = useState(false);
  const [notifications, setNotifications] = useState(3); // Example notification count
  const navigate = useNavigate();
  const { authDetails } = useContext(AuthContext);
  const location = useLocation(); // Get the current route

  const menuItems = [
    { name: "Dashboard", path: "/", activePaths: ["/"] },
    { name: "Customer", path: "/customer", activePaths: ["/customer"] },

    { name: "Reports", path: "/report", activePaths: ["/report"] },

    { name: "Configure", path: "/configure", activePaths: ["/configure"] },

    // {
    //   name: "Subscriptions",
    //   path: "/subscriptions",
    //   activePaths: ["/subscriptions"],
    // },

    { name: "Setting", path: "/setting", activePaths: ["/setting"] },
  ];
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserProfile(false);
      }
    }

    if (userProfile) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [userProfile]);
  const handleLogout = () => {
    setConfirmationModal(true);
  };

  const onConfirmLogout = () => {
    localStorage.clear();
    navigate("/login");
    window.location.reload();
    setConfirmationModal(false);
  };

  return (
    <>
      <nav className="bg-[#ECF6FF] shadow-md">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div
            style={{ margin: "10px" }}
            className="flex justify-between items-center h-16"
          >
            {/* Left Section - Logo & Mobile Menu Button */}
            <div className="flex items-center">
              <button
                onClick={() => setMobileMenu(!mobileMenu)}
                className="sm:hidden text-gray-700 hover:text-gray-900 focus:outline-none"
              >
                {mobileMenu ? <X size={24} /> : <Menu size={24} />}
              </button>
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
                className="w-12 h-12 rounded"
                src={SuryaLogoMain}
                alt="User"
              />
              <span className="ml-3 font-bold text-12">Super Admin</span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden sm:flex text-12">
              {menuItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className={`font-medium transition px-3 py-2 rounded-md 
        ${
          item.activePaths.includes(location.pathname)
            ? "text-white bg-[#E86B1B]"
            : "text-[#135EA0] hover:text-blue-700"
        }
        ${
          index !== 0 ? "ml-2" : ""
        } // Adds left margin except for the first item
      `}
                >
                  {item.name}
                </Link>
              ))}
            </div>

            {/* Notification Bell & Profile Section */}
            <div className="flex items-center space-x-4 relative">
              {/* Notification Bell */}
              <button
                onClick={() => navigate("/notification")}
                className="relative focus:outline-none"
              >
                <Bell size={26} className="text-gray-700 hover:text-gray-900" />
                {/* {notifications > 0 && (
                  <span className="absolute -top-[0.55rem] -right-1 bg-[#E86B1B] text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {notifications}
                  </span>
                )} */}
              </button>

              {/* Profile Picture */}
              <button
                onClick={() => setUserProfile(!userProfile)}
                className="focus:outline-none"
              >
                <img
                  className="w-12 h-12 rounded-full"
                  src={DummyImg}
                  alt="User"
                />
              </button>

              {/* Dropdown Menu */}
              {userProfile && (
                <div
                  ref={dropdownRef}
                  className="z-10 absolute right-0 mt-2 w-60 bg-white rounded-md shadow-lg top-[3rem] ring-1 ring-gray-300"
                >
                  <p className="px-4 py-2 font-bold text-12">
                    Hello, Super Admin
                  </p>
                  <Link
                    className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                    onClick={() => {
                      setUserProfile(false);
                      setUserProfileOpenPopup(true);
                    }}
                  >
                    <User size={16} className="mr-2" /> Profile
                  </Link>

                  <button
                    className="flex w-full items-center px-4 py-2 text-gray-700 hover:bg-gray-200"
                    onClick={handleLogout}
                  >
                    <LogOut size={16} className="mr-2" /> Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenu && (
          <div className="sm:hidden bg-white shadow-md">
            <div className="flex flex-col space-y-2 p-4">
              {menuItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className={`block font-medium rounded-md px-3 py-2 ${
                    location.pathname === item.path
                      ? "text-white bg-[#E86B1B]"
                      : "text-[#135EA0] hover:bg-blue-200"
                  }`}
                  onClick={() => setMobileMenu(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
      {userProfileOpenPopup && (
        <Profile
          isOpen={userProfileOpenPopup}
          onClose={() => setUserProfileOpenPopup(false)}
        />
      )}
      {/* Logout Confirmation Modal */}
      {showConfirmationModal && (
        <LogoutConfirmModal
          show={showConfirmationModal}
          onHide={() => setConfirmationModal(false)}
          onConfirm={onConfirmLogout}
        />
      )}
    </>
  );
};

export default Navbar;
